// @flow
export const filterId: 'orgType' = 'orgType';
